export const mapStateToProps = (state) => {
  return {
    isGetting: state.nipOnboarding.isGettingAllNipApplications || state.nipOnboarding.isGettingSingleNipApplication,
    getSuccess: state.nipOnboarding.getNipApplicationSuccess || state.nipOnboarding.getNipApplicationsSuccess,
    applications: (state.nipOnboarding.nipApplication &&
      state.nipOnboarding.nipApplication.data) || (state.nipOnboarding.nipApplications &&
        state.nipOnboarding.nipApplications.data),
    managerId: state.nipOnboarding.nipApplication &&
      state.nipOnboarding.nipApplication.network_manager_id,
    sendSuccess: state.nipOnboarding.submitRequestSuccess,
    requestSuccess: state.nipOnboarding.submitRequestFormSuccess,
    docs: state.docs.requiredDocs,
    getDocsSuccess: state.docs.getRequiredDocsSuccess,
    kitKey: state.nipOnboarding.nipKit,
    isGettingKeys: state.nipOnboarding.isGettingKit,

  };
};
